import { BasketClient } from '@frontend/basket/api';
import { EntityType } from '@frontend/common';
import { useResolver } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';

declare global {
    interface WindowEventMap {
        'useBasket:request': CustomEvent<string>;
    }
}

const REQUEST_EVENT = 'useBasket:request';
const STORAGE_KEY = 'BSKT_REQ';

export function basketRequest(basketId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_EVENT, { detail: basketId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function BasketResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_EVENT, EntityType.BASKET, (ids) => BasketClient.resolveBaskets(ids), props.dispatch);
    return <></>;
}
